import { render, staticRenderFns } from "./AddOrEditSubTechnologyModal.vue?vue&type=template&id=9e9af306&scoped=true&"
import script from "./AddOrEditSubTechnologyModal.vue?vue&type=script&lang=ts&"
export * from "./AddOrEditSubTechnologyModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e9af306",
  null
  
)

export default component.exports